export const imageColl = window.C.imageColl || window.T.imageColl;
export const utf8Query = imageColl.meta.UTF8Query;



/** WEBPACK FOOTER **
 ** ./src/IIM/core/consts/globals.js
 **/